export class HttpException extends Error {
  public readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class UnauthorizedException extends HttpException {
  static readonly VERIFICATION_FAILED = 'SESSION_VERIFICATION_FAILED';

  static readonly REFRESH_FAILED = 'SESSION_REFRESH_FAILED';

  constructor(message = 'Unauthorized') {
    super(401, message);
  }

  static is(body: unknown): boolean {
    if (!body) {
      return false;
    }

    const status =
      typeof body === 'string'
        ? body
        : typeof body === 'object' && 'status' in body
          ? (body as { status?: unknown }).status
          : undefined;

    return (
      status === UnauthorizedException.VERIFICATION_FAILED ||
      status === UnauthorizedException.REFRESH_FAILED
    );
  }
}
